import {Component, OnInit, HostListener, OnDestroy} from '@angular/core';
import {UserRoleService} from './services/user-role.service';
import {UserRole} from '../../../types/admin-data.types';
import {AdminService} from '../../../services/admin.service';
import {DateTransformer} from '../../../services/date-transformer.service';
import {UrlService} from '../../../services/url.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: './user-role.component.html',
    styleUrls: ['./user-role.component.scss']
})

export class UserRoleComponent implements OnInit, OnDestroy {

    public isShowView: boolean = false;
    public viewedItem: UserRole;
    public isCreateNew: boolean = false;

    constructor(public adminService: AdminService,
                public urlService: UrlService,
                public userRoleService: UserRoleService) {
    }

    ngOnInit() {
        this.userRoleService.account.navigateIfServiceDisallowed('auth', '/home');
        this.userRoleService.urlService.onUrlChange
            .pipe(
                tap(() => this.isShowView = false),
                flatMap(() => this.userRoleService.getByQueryParams().pipe(takeUntil(this.userRoleService.urlService.instantOnUrlChange)))
            )
            .subscribe();
        this.userRoleService.urlService.setQueryParams('user-role');
        this.userRoleService.getCorporationNumber();
        this.userRoleService.getBuildings();
    }

    removeItem() {
        this.userRoleService.remove(this.viewedItem.id).subscribe(() => {
            this.closeDetails();
        });
    }

    updateItem(id: number, data: Object) {
        this.closeDetails();
        this.userRoleService.update(id, data).subscribe(res => {
            const currentUser = JSON.parse(localStorage.getItem('userData'));
            if (res.usersData[currentUser.id])
                document.location.reload(true);
            else
                this.userRoleService.get();
        });
    }

    createItem(data: Object) {
        return this.userRoleService.create(data).map((res: UserRole) => {
            this.userRoleService.get();
        });
    }

    toggleDetails(item: UserRole = this.viewedItem): void {
        this.userRoleService.showAmenityPermissionsTable = false;
        this.isShowView = this.userRoleService.toggleCheckRole(item);
        if (this.isShowView) {
            this.viewedItem = item;
        }
    }

    closeDetails(): void {
        if (this.viewedItem) this.viewedItem.checked = false;
        this.isShowView = false;
    }

    createNew(): void {
        this.isCreateNew = true;
    }

    closeCreateNew(): void {
        this.isCreateNew = false;
        this.urlService.modalClosed.emit();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.userRoleService.emptyRowService.fillEmptyRow();
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.userRoleService.urlService.resetQueryParams();
        this.userRoleService.data = [];
        this.isShowView = false;
    }

    removeAllObservers() {
        this.userRoleService.urlService.onUrlChange.observers = [];
    }

    transformDate(date: Date): string {
        return DateTransformer.transformDate(date);
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/user-role/user-role.component.ts